import React, { useEffect, useState } from "react";
import styles from "./manufacturer-product-name.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

const cssClassName = "manufacturer-product-name";

interface BuildTypeTypes {
  hostname: string;
  name: string;
  port: number;
}

export const ManufacturerProductName = () => {
  const connectionInfo = useSelector(
    (state: RootState) => state.yourSlice.connectionView,
  );
  const [loadedConnectionInfo, setLoadedConnectionInfo] =
    useState<BuildTypeTypes>();

  useEffect(() => {
    if (!connectionInfo) return;
    setLoadedConnectionInfo(connectionInfo.source);
  }, [connectionInfo]);

  return (
    <>
      {loadedConnectionInfo && (
        <div className={styles[cssClassName]}>
          <p className={styles[`${cssClassName}__name`]}>
            {loadedConnectionInfo.name}
          </p>
          <p
            className={styles[`${cssClassName}__ip-port`]}
          >{`${loadedConnectionInfo.hostname}:${loadedConnectionInfo.port}`}</p>
        </div>
      )}
    </>
  );
};
